import { EmobilityResultPanel } from './emobilityResultPanel';
import { withStyles } from 'tss-react/mui';
import { CSSObject } from 'tss-react';

export const ResponsiveEmobilityResultPanel = withStyles(EmobilityResultPanel, theme => ({
	root: {
		[theme.breakpoints.up('sm')]: {
			padding: 32
		},
		[theme.breakpoints.up('md')]: {
			paddingBottom: 40
		},
		[theme.breakpoints.up('xl')]: {
			padding: 48,
			paddingBottom: 41
		}
	},
	result: {
		[theme.breakpoints.up('sm')]: {
			'&.nobonus': {
				marginBottom: 85
			}
		},
		[theme.breakpoints.up('md')]: {
			fontSize: '38px',
			lineHeight: '48px'
		},
		[theme.breakpoints.up('lg')]: {
			fontSize: '44px',
			lineHeight: '52px',
			marginBottom: 32,
			'&.nobonus': {
				marginBottom: 100
			}
		},
		[theme.breakpoints.up('xl')]: {
			'&.nobonus': {
				marginBottom: 85
			}
		}
	},
	panelContent: {
		[theme.breakpoints.up('sm')]: {
			margin: 0
		},
		[theme.breakpoints.up('lg')]: {
			margin: '-24px 0'
		},
		[theme.breakpoints.up('xl')]: {
			margin: 0
		}
	},
	panelBonuses: {
		[theme.breakpoints.up('sm')]: {
			padding: 0
		},
		[theme.breakpoints.up('md')]: {
			margin: -5
		},
		[theme.breakpoints.up('lg')]: {
			padding: '24px 0'
		},
		[theme.breakpoints.up('xl')]: {
			padding: 0
		}
	},
	bonus: {
		[theme.breakpoints.up('md')]: {
			padding: 5,
			fontSize: '18px',
			lineHeight: '28px'
		}
	},
	checker: {
		marginRight: '10px'
	},
	image: {
		[theme.breakpoints.up('sm')]: {
			padding: 0,
			marginTop: 'calc(-17.507% - 10px)',
			marginBottom: 'calc(-11.298% - 10px)',
			width: 'calc(100% + 64px)'
		},
		[theme.breakpoints.up('lg')]: {
			padding: '24px 0'
		},
		[theme.breakpoints.up('xl')]: {
			padding: 0,
			width: '726px',
			marginRight: '-48px',
			marginLeft: 'auto',
			marginTop: '-182px',
			marginBottom: '-83px',
			'&.nobonus': {
				width: '100%',
				marginTop: 'calc(-17.507%)',
				marginBottom: 'calc(-11.298%)',
				marginLeft: 0,
				marginRight: 0
			}
		}
	},
	panelButtonAndNote: {
		[theme.breakpoints.up('sm')]: {
			paddingTop: 60,
			flexDirection: 'row',
			justifyContent: 'center'
		} as CSSObject,
		[theme.breakpoints.up('md')]: {
			paddingTop: 33
		},
		[theme.breakpoints.up('lg')]: {
			paddingTop: 68
		},
		[theme.breakpoints.up('xl')]: {
			paddingTop: 80,
			'&.nobonus': {
				paddingTop: 30
			}
		}
	},
	containerNote: {

	},
	containerButton: {
		[theme.breakpoints.up('md')]: {
			marginLeft: 'auto'
		}
	},
	dividerFooter: {
		[theme.breakpoints.up('lg')]: {
			margin: '32px 0'
		}
	},
	loader: {

	},
	resultLabel: {

	}
}));
